import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { styles } from "./styles";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, createSearchParams } from "react-router-dom";
import { allFilters } from "../../redux/actions/filterActions";
import InputField from "../InputFields/InputField";
import { Button } from "../Buttons";
import { STRINGS } from "./strings";

function valuetext(value) {
  return `${value}`;
}

const minDistance = 1; // Minimum distance of 1 year between min and max

const FilterTypeCompanyFoundedOn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [tempMinFounded, setTempMinFounded] = useState(null);
  const allFiltersSelector = useSelector((state) => state.allFilters);

  // Set initial values from Redux or defaults (1980-2025)
  const [value, setValue] = useState([
    parseInt(allFiltersSelector?.payload?.min_founded_on) || 1980,
    parseInt(allFiltersSelector?.payload?.max_founded_on) || 2025,
  ]);

  // Sync with Redux store when external changes occur
  if (tempMinFounded !== allFiltersSelector?.payload?.min_founded_on) {
    setTempMinFounded(allFiltersSelector?.payload?.min_founded_on);
    setValue([
      parseInt(allFiltersSelector?.payload?.min_founded_on) || 1980,
      parseInt(allFiltersSelector?.payload?.max_founded_on) || 2025,
    ]);
  }

  // Handle slider changes
  const handleChange1 = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    if (activeThumb === 0) {
      setValue([Math.min(newValue[0], value[1] - minDistance), value[1]]);
    } else {
      setValue([value[0], Math.max(newValue[1], value[0] + minDistance)]);
    }
  };

  // Handle input field changes
  const handleChange = (e, index) => {
    let res = [];
    const yearValue = parseInt(e.target.value);

    // Validate year is within range (1980-2025)
    if (!isNaN(yearValue) && yearValue >= 1980 && yearValue <= 2025) {
      index === 0
        ? (res = [yearValue, value[1]])
        : (res = [value[0], yearValue]);
      setValue(res);
    }
  };

  // Submit filter
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      allFilters({
        min_founded_on: parseInt(value[0]),
        max_founded_on: parseInt(value[1]),
      })
    );
    navigate({
      pathname: location.pathname,
      search: createSearchParams({
        ...allFiltersSelector?.payload,
        min_founded_on: parseInt(value[0]),
        max_founded_on: parseInt(value[1]),
      }).toString(),
    });
  };

  // Clear filter
  const handleClearFilter = () => {
    const query = JSON.parse(JSON.stringify(allFiltersSelector?.payload));
    delete query?.min_founded_on;
    delete query?.max_founded_on;
    dispatch(allFilters(query, true));
    navigate({
      pathname: location.pathname,
      search: createSearchParams({
        ...query,
      }).toString(),
    });
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.filterContainer}>
        <Box>
          <Box
            sx={{
              ...styles.jobTitleHead,
              columnGap: "15px",
              marginBottom: "10px",
            }}
          >
            <label style={styles.sliderLabel}>{value[0]}</label>
            <Slider
              sx={styles.slider}
              value={value}
              onChange={handleChange1}
              valueLabelDisplay="auto"
              getAriaValueText={valuetext}
              disableSwap
              min={1980}
              max={2025}
            />
            <label style={styles.sliderLabel}>{value[1]}</label>
          </Box>
          <Box sx={styles.containRevenueInputs}>
            <InputField
              size={"xs34"}
              value={value[0]}
              placeholder="1980"
              onChange={(e) => handleChange(e, 0)}
            />
            <InputField
              size={"xs34"}
              value={value[1]}
              placeholder="2025"
              onChange={(e) => handleChange(e, 1)}
            />
          </Box>
          <Box sx={styles.containBtn} onSubmit={handleSubmit} component="form">
            {allFiltersSelector?.payload?.max_founded_on ? (
              <div>
                <Button
                  label={STRINGS.CANCEL}
                  size={"xs28"}
                  variant={"ghost"}
                  onClick={handleClearFilter}
                />
              </div>
            ) : null}
            <div>
              <Button
                label={STRINGS.APPLY}
                size={"xs28"}
                variant={"primary"}
                type="submit"
              />
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FilterTypeCompanyFoundedOn;
